import Swiper, { Autoplay, Scrollbar } from "swiper";

let BoxesImageText;
const swiperContainer = document.querySelector(".boxes-image-text__carousel");

if (swiperContainer) {
  const swiperWrapper = swiperContainer.firstChild;
  const swiperItems = swiperWrapper.children;
  const dragSlider = swiperContainer.querySelector(".swiper-scrollbar");

  const swiperConfig = {
    modules: [Autoplay, Scrollbar],
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 1.15,
    spaceBetween: 20,
    scrollbar: {
      el: dragSlider,
      draggable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.15,
      },
      1024: {
        slidesPerView: 3.15,
      },
    },
  };

  function initSwiper() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 1280 && BoxesImageText === undefined) {
      swiperContainer.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      [...swiperItems].map((e) => e.classList.add("swiper-slide"));
      BoxesImageText = new Swiper(swiperContainer, swiperConfig);
    } else if (screenWidth >= 1280 && BoxesImageText !== undefined) {
      BoxesImageText.destroy();
      BoxesImageText = undefined;
      swiperContainer.classList.remove("swiper");
      swiperWrapper.removeAttribute("style");
      swiperWrapper.classList.remove("swiper-wrapper");
      [...swiperItems].map((e) => e.classList.remove("swiper-slide"));
    }
  }

  initSwiper();

  window.addEventListener(
    "resize",
    function (event) {
      initSwiper();
    },
    true
  );
}
